import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { merge } from 'lodash-es';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient);

  private readonly domains = [
    'accounting',
    'activity-tracking',
    'assistant',
    'buildings',
    'contracts',
    'crops',
    'dashboard',
    'document',
    'equipment',
    'exceptions',
    'farm',
    'fertilizers',
    'fields',
    'insurance',
    'inventory',
    'invitation',
    'layout',
    'livestock',
    'menu',
    'notifications',
    'onboarding',
    'reports',
    'settings',
    'tasks',
    'team',
    'tour',
    'transactions',
    'upcoming-features',
    'weather',
    'drafts',
  ];

  public getTranslation(lang: string): Observable<Record<string, string>> {
    const langKey = lang.split('-')[0] || 'en';

    const requests = [
      this.http.get<Record<string, unknown>>(`assets/i18n/${langKey}.json`),
      ...this.domains.map((domain) =>
        this.http
          .get<Record<string, unknown>>(
            `assets/i18n/${domain}/${langKey}.json`
          )
          .pipe(catchError(() => of({})))
      ),
    ];

    return forkJoin(requests).pipe(
      map((responses) => merge({}, ...responses) as Record<string, string>)
    );
  }
}
